import { useDispatch, useSelector } from "react-redux";
import { getContentKeyAccToLang, showToast } from "../../utils/utils";
import { use, useEffect, useState } from "react";
import dynamicfunction from "../../utils/dynamicfunction";
import { useLocation, useNavigate } from "react-router";
import { initiatePayment, paymentsMoyassarHistory } from "../../store/actions/investmentsAction";
import { clientSuspendedToast } from "../../utils/functions";
export default () => {
  const { isArabic, TextWeight } = dynamicfunction();
  const dispatch = useDispatch()
  const { investmentContent } = useSelector((state) => state.content);
  const { clientDetails, investmentLoading, initiate_payment_loading } = useSelector((state) => state.investments);
  const { user } = useSelector((state) => state.common);

  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      investmentContent?.web_investment_overview?.data?.attributes,
      key,
      isArabic
    );
  };
  useEffect(() => {
    const search = location.search;
    const queryIndex = search.indexOf("?");
    if (queryIndex !== -1) {
      const queryString = search.substring(queryIndex + 1);
      const searchParams = new URLSearchParams(queryString);

      const status = searchParams.get("status");
      const message = searchParams.get("message");
      const isPaid = status === "paid";

      if (status) {
        const amount = searchParams.get("amount");
        const apiData = {
          amount: String(amount),
          isDebiting: false,
          remarks_Ar: "إعادة شحن",
          remarks_En: "Top up"
        }
        if (status === "paid") {
          dispatch(paymentsMoyassarHistory(apiData, () => {
            window.history.replaceState(
              {},
              document.title,
              window.location.pathname
            );
          }))
        } else {
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname
          );
        }
        showToast({
          icon: isPaid ? "success" : "error",
          title: getContentKey(isPaid ? "topup_success_message" : "topup_failure_message")
        });
      }
    }

    window.history.replaceState(null, "", "#" + location.pathname);
  }, []);

  const isTransfersTopup = location?.pathname === '/transfers/topup';

  useEffect(() => {
    if (user?.isClientSuspended && (isTransfersTopup)) {
      clientSuspendedToast(isArabic);
      navigate(-1)
    }
  }, [user?.isClientSuspended])

  const PaymentFormSubmitter = async () => {
    const api_data = {
      clientId: clientDetails?.clientInformation?.clientId ?? "",
      amount: amount,
      callbackUrl: window.location.href ?? ""
    }
    dispatch(initiatePayment(api_data))
  };

  return {
    TextWeight,
    getContentKey,
    clientDetails,
    amount,
    setAmount,
    isArabic,
    PaymentFormSubmitter,
    navigate,
    error,
    setError,
    investmentLoading,
    initiate_payment_loading,
  };
};
